import React from 'react';
import Check from '@/components/commons/icons/Check';
import { categorizeQuestions } from '../helpers';
import Answer from './Answer';

function ReviewAnswers({
    closeModal,
    answers,
    saveQuestionData,
    currentlySending,
}) {
    const categorizedQuestions = categorizeQuestions(answers);

    return (
        <div className="relative flex flex-col items-center justify-center w-full h-full">
            <div className="w-full bg-cirrusWhite rounded-t-lg flex items-start justify-between py-8 px-10 ">
                <div className="flex flex-col w-[390px]">
                    <p className="text-[30px] font-bold font-jazmin">Review my answers </p>
                    <p className="text-[16px]"> Review the contact questions shared with you, and the answers you selected. Revise them as needed. </p>
                </div>
                <button
                    type="button"
                    data-tooltip-id="tip"
                    title="I’m done"
                    aria-label="I’m done"
                    onClick={() => closeModal()}
                    className="w-min rounded-lg bg-green-400 flex items-center justify-center py-2 px-4 my-2 pt-[6px] mr-0 "
                >
                    <div className="flex items-center justify-center px-1 py-1">
                        <div className="mr-2 w-6">
                            <Check className="w-6 h-6 text-white" />
                        </div>
                        <p className="font-medium min-w-[65px] text-cirrusWhite">I’m done</p>
                    </div>
                </button>
            </div>
            <div className="w-full h-full flex flex-col items-start justify-between py-8 px-10 bg-lightGray">
                {Object.keys(categorizedQuestions).map((category, categoryIndex) => {
                    const categoryItems = categorizedQuestions[category];
                    if (categoryItems.length > 0) {
                        return (
                            <div className="w-full">
                                <p className={`text-[16px] font-semibold ${categoryIndex !== 0 ? 'mt-6' : ''}`}>{categoryItems[0].question.reviewTitle}</p>
                                {categoryItems.map((element) => (
                                    <Answer
                                        questionInfo={element}
                                        saveQuestionData={saveQuestionData}
                                        currentlySending={currentlySending}
                                    />
                                ))}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
}

export default ReviewAnswers;
